export default __webpack_public_path__ + "static/media/images2.85bcc506.png";